<div class="modal-header">
  <h4 class="modal-title">{{ 'legend.modalHeader.title' | translate }}</h4>
  <button type="button" class="close" (click)="closeModal()">{{ 'legend.modalHeader.closeButton' | translate }}</button>
</div>
<div class="modal-body">
  <ul class="legend-list">
    <li><span class="color-dot black"></span> {{ 'legend.items.standardCopy' | translate }}</li>
    <li><span class="color-dot red"></span> {{ 'legend.items.adrc' | translate }}</li>
    <li><span class="color-dot green"></span> {{ 'legend.items.circulation' | translate }}</li>
    <li><span class="color-dot violet"></span> {{ 'legend.items.noBilling' | translate }}</li>
    <li><span class="color-dot blue"></span> {{ 'legend.items.specialRequest' | translate }}</li>
    <li><span class="color-dot orange"></span> {{ 'legend.items.copySharing' | translate }}</li>
    <li><span class="color-dot red"></span> {{ 'legend.items.announcedSchedule' | translate }}</li>
    <li><span class="color-dot italic"></span> <span class="italic-text">{{ 'legend.items.filmArtEtEssai' | translate }}</span></li>
  </ul>
</div>
